mutation registerUser($input: RegisterUserInput!) {
  registerUser: registerUser(input: $input) {
    companyId
  }
}
